<template lang="pug">
main.pesquisa-inteligente
    .pesquisa-inteligente__barra-pesquisa
        i.el-icon-search

        input.pesquisa-inteligente__input(
            v-model='filtro',
            type='text',
            :placeholder='placeholderPais()',
            :disabled='usuarioIsLaudo',
            autocomplete='off',
            :trigger-on-focus="false",
            @input="tratarPesquisaInteligente(filtro)",
            @keyup.enter='realizarPesquisaExata',
            @blur='fecharLista'
        )

    transition(name='el-zoom-in-top')
        ul.pesquisa-inteligente__ul(v-show='mostrarLista')
            .mb-2(v-for='(opcao, idx) in opcoes')
                span.pesquisa-inteligente__categoria(
                    v-if='opcao.resultado.length'
                ) {{ internacionalizarCategoria(opcao.categoria) }}
                span(v-if='opcao.resultado.length > 0').counter.ml-2 {{ opcao.resultado.length }}

                li(v-for='resultado in opcao.resultado', :class='validarUltimoDaLista(resultado, opcao.resultado) ? "" : "borda"')
                    span(@click='mapearAcao(resultado.id, opcao.codigo)') {{ resultado.valor }}
                    div(style='display: flex;')
                        el-tooltip(
                            effect='dark'
                            :content="$t('mensagens.home.pesquisaInteligente.visualizarImovel')"
                            placement='top',v-if='validarPermissao(roleImovel) && opcao.codigo === "TERRITORIO"')
                            .icone(@click='visualizarTerritorio(resultado.id)')
                                i.lyra-icon.lyra-olho
                        el-tooltip(
                            effect='dark'
                            :content="$t('mensagens.home.pesquisaInteligente.solicitarLaudoConformidadeAmbiental')"
                            placement='top'
                        )
                            .icone(v-if='validarPermissao(roleLaudoConformidadeAmbiental) && (opcao.codigo === "TERRITORIO" || opcao.codigo === "CAR")', @click='irLaudoConformidadeAmbiental(resultado, opcao.codigo)')
                                i.lyra-icon.lyra-laudos
                        el-tooltip(
                            effect='dark'
                            :content="$t('mensagens.home.pesquisaInteligente.consultarPreAnalise')"
                            placement='top'
                        )
                            .icone(v-if='validarPermissao(rolePreAnaliseCredito) && opcao.codigo === "REPRESENTANTE"', @click='abrirModalPreAnaliseCredito(resultado.documento)')
                                i.lyra-icon.lyra-pre-analise-credito
                        el-tooltip(
                            effect='dark'
                            :content="$t('mensagens.home.pesquisaInteligente.realizarDiagnosticoSocio')"
                            placement='top'
                        )
                            .icone(v-if='validarPermissao(roleDiagnosticoSocioambiental) && (opcao.codigo === "REPRESENTANTE" || opcao.codigo === "CAR")', @click='irDiagnosticoSocioambiental(opcao.codigo, resultado)')
                                i.lyra-icon.lyra-diagnostico-socio
                        el-tooltip(
                            effect='dark'
                            :content="$t('mensagens.home.pesquisaInteligente.enviarParaMonitoramentoSocio')"
                            placement='top'
                        )
                            .icone(v-if='validarPermissao(roleMonitoramentoSocioambiental) && opcao.codigo === "REPRESENTANTE" && !resultado.areaEmMonitoramento && resultado.possuiTerritorios', @click='novoMonitoramentoSocioambiental(opcao.codigo, resultado)')
                                i.lyra-icon.lyra-arvore
                        el-tooltip(
                            effect='dark'
                            :content="resultado.areaEmMonitoramento ? $t('mensagens.home.pesquisaInteligente.visualizarMonitoramentoSocio') : $t('mensagens.home.pesquisaInteligente.enviarParaMonitoramentoSocio')"
                            placement='top'
                        )
                            .icone(v-if='validarPermissao(roleMonitoramentoSocioambiental) && opcao.codigo === "TERRITORIO" && resultado.areaEmMonitoramento', @click='visualizarAreaMonitorada(resultado.areaEmMonitoramentoId)')
                                i.lyra-icon-monitoramento.lyra-visualizar-monitoramento-socio-ambiental
                            .icone(v-else-if='validarPermissao(roleMonitoramentoSocioambiental) && opcao.codigo === "TERRITORIO" && !resultado.areaEmMonitoramento', @click='novoMonitoramentoSocioambiental(opcao.codigo, resultado)')
                                i.lyra-icon.lyra-arvore
                        el-tooltip(
                            effect='dark'
                            :content="$t('mensagens.home.pesquisaInteligente.enviarParaMonitoramentoAgricola')"
                            placement='top'
                        )
                            .icone(v-if='validarPermissao(roleMonitoramentoAgricola) && opcao.codigo === "TERRITORIO"', @click='irMonitoramentoAgricola(resultado)')
                                i.lyra-icon.lyra-agricola

            .mb-2.pesquisa-inteligente__cadastro-container(v-if='semResultado')
                .pesquisa-inteligente__cadastro
                    span.fica-a-dica-titulo
                        | {{ $t('mensagens.home.pesquisaInteligente.ficaDica') }}:&nbsp;
                    span.fica-a-dica-texto
                        | {{ $t('mensagens.home.pesquisaInteligente.naoEncontrouBusca') }}
                .pesquisa-inteligente__cadastro
                    BaseButton.pesquisa-inteligente__btn-cadastro(
                        v-if='ficaADica === "CPF/CNPJ" || ficaADica === "Pessoa"'
                        size='medium',
                        @click='cadastrarRepresentante(ficaADica)',
                    )
                        i.el-icon-circle-plus-outline.mr-1
                        | {{ $t(ambientePy ? 'mensagens.home.pesquisaInteligente.cadastrarProdutor' : 'mensagens.home.pesquisaInteligente.cadastrarPessoa') }}
                    BaseButton.pesquisa-inteligente__btn-cadastro(
                        v-if='ficaADica === "Pessoa" || ficaADica === "CAR"'
                        size='medium',
                        @click='cadastrarTerritorio',
                    )
                        i.el-icon-circle-plus-outline.mr-1
                        | {{ $t('mensagens.home.pesquisaInteligente.cadastrarTerritorio') }}

                    BaseButton.pesquisa-inteligente__btn-cadastro.socioambiental(
                        v-if='ficaADica === "CPF/CNPJ" || ficaADica === "CAR"'
                        size='medium',
                        @click='realizarDiagnosticoSocioambiental(ficaADica)',
                    )
                        i.lyra-icon.lyra-diagnostico-socio.mr-1
                        | {{ $t('mensagens.home.pesquisaInteligente.realizarDiagnosticoSocio') }}

                    BaseButton.pesquisa-inteligente__btn-cadastro.socioambiental(
                        v-if='ficaADica === "CPF/CNPJ" && validarPermissao(rolePreAnaliseCredito)'
                        size='medium',
                        @click='abrirModalPreAnaliseCredito(null)',
                    )
                        i.lyra-icon.lyra-pre-analise-credito.mr-1
                        | {{ $t('mensagens.home.pesquisaInteligente.consultaPreAnaliseCredito') }}

    ModalDiagnosticoSocioambientalRepresentante(
        confirmar,
        :mostrar='mostrarModalDiagnosticoSocioambiental',
        :dadosRepresentante='representante',
        @fechar='mostrarModalDiagnosticoSocioambiental = false'
    )
    ModalConfirmacaoPreAnaliseCredito(
        :show='abrirModalConfirmacaoPreAnaliseCredito',
        :cpfCnpj='cpfCnpjModalPreAnaliseCredito ? cpfCnpjModalPreAnaliseCredito : filtro',
        width='500px',
        @closeDialog='abrirModalConfirmacaoPreAnaliseCredito = false',
        @processar='realizarPreAnaliseCredito(cpfCnpjModalPreAnaliseCredito ? cpfCnpjModalPreAnaliseCredito : filtro)'
    )
</template>

<script>
import PesquisaInteligenteService from '@/services/PesquisaInteligenteService';
import RepresentanteService from '@/services/RepresentanteService';
import TerritorioService from '@/services/TerritorioService';

import formatters from '@/utils/formatters';
import validators from '@/utils/validators';
import CarUtils from '@/utils/CarUtils';

import ModalDiagnosticoSocioambientalRepresentante from '@/components/ModalDiagnosticoSocioambientalRepresentante.vue';
import ModalConfirmacaoPreAnaliseCredito from '@/components/home/ModalConfirmacaoPreAnaliseCredito.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'PesquisaInteligente',

    components: {
        ModalDiagnosticoSocioambientalRepresentante,
        ModalConfirmacaoPreAnaliseCredito,
        BaseButton
    },

    data() {
        return {
            filtro: '',
            opcoes: [],
            mostrarLista: false,
            representante: {},
            mostrarModalDiagnosticoSocioambiental: false,
            rolePreAnaliseCredito: [
                'ROLE_ADMINISTRATOR',
                'ROLE_REGULAR',
                'FEATURE_PRE_ANALISE_CREDITO'
            ],
            roleDiagnosticoSocioambiental: [
                'ROLE_ADMINISTRATOR',
                'ROLE_REGULAR',
                'ROLE_OPERACAO_CADASTRANTE'
            ],
            roleImovel: [
                'ROLE_ADMINISTRATOR',
                'ROLE_REGULAR',
                'ROLE_FEATURE_COMPARTILHAMENTO_DADOS'
            ],
            roleLaudoConformidadeAmbiental: [
                'ROLE_ADMINISTRATOR',
                'ROLE_REGULAR',
                'ROLE_OPERACAO_APROVADOR'
            ],
            roleMonitoramentoSocioambiental: [
                'ROLE_ADMINISTRATOR',
                'ROLE_REGULAR',
                'ROLE_MONITORAMENTO_SOCIOAMBIENTAL'
            ],
            roleMonitoramentoAgricola: [
                'ROLE_ADMINISTRATOR',
                'ROLE_REGULAR',
                'ROLE_MONITORAMENTO_AGRICOLA'
            ],
            timerId: null,
            ficaADica: 'Pessoa',
            semResultado: false,
            abrirModalConfirmacaoPreAnaliseCredito: false,
            cpfCnpjModalPreAnaliseCredito: ''
        };
    },
    computed: {
        ...mapState(['usuarioLogado', 'usuarioIsLaudo']),
        ...mapGetters(['ambientePy'])
    },

    methods: {
        async realizarPesquisa(pesquisaExata) {
            this.semResultado = false;
            this.ProcessarFicaADicar(this.filtro);
            if (!this.filtro) return this.limpar();

            const { data } =
                await PesquisaInteligenteService.realizarPesquisaHome(
                    this.filtro,
                    pesquisaExata || false
                );
            this.opcoes = data;
            this.mostrarLista = true;

            const semResultado = !this.opcoes.filter(
                ({ resultado }) => resultado.length
            ).length;
            if (semResultado) {
                this.semResultado = true;
            }
        },

        ProcessarFicaADicar(filtro) {
            if (filtro && filtro.length >= 3) {
                if (!filtro.includes(' ') && (this.isCNPJ(filtro) || this.isCPF(filtro) || filtro.length === 14 || filtro.length === 18 ||
                filtro.length === 11)) {
                    this.ficaADica = 'CPF/CNPJ';
                } else if ((filtro.length === 41 || filtro.length === 43) && CarUtils.isCar(filtro) && !filtro.includes(' ')) {
                    this.ficaADica = 'CAR';
                } else if (typeof filtro === 'string' && validators.validarNomePessoa(filtro) && !CarUtils.isCar(filtro)) {
                    this.ficaADica = 'Pessoa';
                } else {
                    this.ficaADica = 'Pessoa';
                }
            }
        },

        isCPF(input) {
            const numbers = formatters.removerPontuacaoDocumento(input);
            return numbers.length === 11 && validators.validarCPF(numbers);
        },

        isCNPJ(input) {
            const numbers = formatters.removerPontuacaoDocumento(input);
            return numbers.length === 14 && validators.validarCNPJ(numbers);
        },

        realizarPesquisaExata() {
            clearTimeout(this._timerId);
            this.realizarPesquisa(true);
        },

        limpar() {
            this.items = [];
            this.filtro = '';
            this.mostrarLista = false;
        },

        fecharLista() {
            setTimeout(() => {
                this.mostrarLista = false;
            }, 300);
        },

        tratarPesquisaInteligente(filtro) {
            clearTimeout(this._timerId);

            if (filtro.length >= 3) {
                this._timerId = setTimeout(() => {
                    this.realizarPesquisa();
                }, 2000);
            }
        },

        mapearAcao(id, tipo) {
            this.mostrarLista = false;
            switch (tipo) {
                case 'REPRESENTANTE':
                    this.realizarDiagnosticoSocioambientalRepresentante(id);
                    break;
                case 'TERRITORIO':
                    this.visualizarTerritorio(id);
                    break;
                case 'CAR':
                    this.realizarDiagnosticoSocioambientalCAR(id);
                    break;
                case 'MUNICIPIO':
                    this.visualizarMunicipio(id);
                    break;
            }
        },

        async realizarDiagnosticoSocioambientalRepresentante(id) {
            await this.buscarRepresentante(id);
            this.mostrarModalDiagnosticoSocioambiental = true;
        },

        async buscarRepresentante(id) {
            const { data } = await RepresentanteService.findById(id);

            this.representante = {
                nome: data.nomeRazaoSocial,
                cpfCnpj: formatters.numeralStringFormatToDocumento(data.cpfCnpj),
                email: data.email
            };
        },

        realizarDiagnosticoSocioambientalCAR(car) {
            this.$router.push({
                name: 'DiagnosticoSocioambiental',
                params: { pesquisa: car }
            });
        },

        visualizarTerritorio(id) {
            this.$router.push({
                name: 'VisualizarTerritorio',
                params: { idTerritorio: id }
            });
        },

        visualizarMunicipio(id) {
            this.$router.push({ name: 'SIG', params: { idMunicipio: id } });
        },

        cadastrarRepresentante(tipo) {
            if (tipo === 'CPF/CNPJ') {
                this.$router.push({
                    name: 'Pessoa',
                    params: { cadastrar: formatters.removerPontuacaoDocumento(this.filtro) }
                });
            } else {
                this.$router.push({
                    name: 'Pessoa',
                    params: { cadastrar: this.filtro }
                });
            }
        },

        cadastrarTerritorio() {
            this.$router.push({
                name: 'CadastrarEditarTerritorio',
                params: { cadastrar: this.filtro }
            });
        },

        realizarDiagnosticoSocioambiental(tipo) {
            let documento = this.filtro;
            if (tipo === 'CPF/CNPJ') {
                documento = formatters.removerPontuacaoDocumento(this.filtro);
            }

            this.$router.push({
                name: 'DiagnosticoSocioambiental',
                params: {pesquisa: formatters.numeralStringFormatToDocumento(documento)}
            });
        },

        abrirModalPreAnaliseCredito(cpfCnpjResultados) {
            if (cpfCnpjResultados) {
                this.cpfCnpjModalPreAnaliseCredito = formatters.removerPontuacaoDocumento(cpfCnpjResultados);
            } else {
                this.cpfCnpjModalPreAnaliseCredito = null;
            }
            this.abrirModalConfirmacaoPreAnaliseCredito = true;
        },

        realizarPreAnaliseCredito(cpfCnpj) {
            this.$router.push({
                name: 'PreAnaliseCredito',
                params: { cpfCnpj: formatters.documentoFormatToNumeral(cpfCnpj) }
            });
        },

        validarUltimoDaLista(index, lista) {
            if (lista.length > 0) {
                let ultimoDaLista = lista[lista.length - 1];
                return index.id === ultimoDaLista.id;
            } else {
                return false;
            }
        },
        validarPermissao(roles) {
            const restrictedRolesPY = [
                'FEATURE_PRE_ANALISE_CREDITO',
                'ROLE_OPERACAO_CADASTRANTE',
                'ROLE_OPERACAO_APROVADOR',
                'ROLE_MONITORAMENTO_AGRICOLA'
            ];
            let resultado = false;

            if (this.ambientePy && this.hasRestrictedRole(roles, restrictedRolesPY)) {
                return resultado;
            } else {
                this.usuarioLogado.authorities.forEach(roleKey => {
                    if (roles.includes(roleKey.authority)) {
                        resultado = true;
                    }
                });
                return resultado;
            }
        },
        hasRestrictedRole(roles, restrictedRoles) {
            return roles.some(role => restrictedRoles.includes(role));
        },
        irDiagnosticoSocioambiental(codigo, resultado) {
            if (codigo === 'CAR') {
                this.realizarDiagnosticoSocioambientalCAR(resultado.valor);
            }
            if (codigo === 'REPRESENTANTE') {
                this.$router.push({
                    name: 'DiagnosticoSocioambiental',
                    params: {pesquisa: resultado.documento}
                });
            }
        },
        novoMonitoramentoSocioambiental(codigo, resultado) {
            if (codigo === 'REPRESENTANTE') {
                let valor = 'REPRESENTANTE==' + resultado.valor;
                this.$router.push({
                    name: 'CadastrarMonitoramentoSocioAmbiental',
                    params: {valor: valor, id: resultado.id}
                });
            }
            if (codigo === 'TERRITORIO') {
                let valor = 'TERRITORIO==' + resultado.valor;
                this.$router.push({
                    name: 'CadastrarMonitoramentoSocioAmbiental',
                    params: {valor: valor, id: resultado.id}
                });
            }
        },
        visualizarAreaMonitorada(id) {
            this.$router.push({
                name: 'VisualizarMonitoramentoSocioambiental',
                params: {idAreaMonitorada: id, voltarHome: true}
            });
        },
        irMonitoramentoAgricola(resultado) {
            let valor = 'TERRITORIO==' + resultado.valor;
            this.$router.push({
                name: 'CadastrarMonitoramentoAgricola',
                params: {valor: valor, id: resultado.id}
            });
        },
        async irLaudoConformidadeAmbiental(resultado, opcao) {
            if (opcao === 'TERRITORIO') {
                this.$router.push({
                    name: 'LaudoSolicitacaoConformidadeAmbiental',
                    params: {territoriosIdsPesquisaInteligente: [resultado.id]}
                });
            } else if (opcao === 'CAR') {
                let params = await this.fetchTerritoriosPorCAR(resultado.valor);

                this.$router.push({
                    name: 'LaudoSolicitacaoConformidadeAmbiental',
                    params: {territoriosIdsPesquisaInteligente: params}
                });
            }
        },
        async fetchTerritoriosPorCAR(search) {
            let filtroFindTerritorioPorCAR = {
                page: 0,
                size: 10,
                search: search
            };
            const { data } = await TerritorioService.findIdsLista(filtroFindTerritorioPorCAR);

            return data.content;
        },

        placeholderPais() {
            if (this.ambientePy) {
                return this.$t(`mensagens.home.pesquisaInteligente.placeholderParaguai`);
            } else {
                return this.$t(`mensagens.home.pesquisaInteligente.placeholder`);
            }
        },

        internacionalizarCategoria(val) {
            const categoria = val.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
            if (this.ambientePy) {
                if (categoria === 'pessoa') {
                    return this.$t('mensagens.home.pesquisaInteligente.categoria.produtor');
                } else {
                    return this.$t(`mensagens.home.pesquisaInteligente.categoria.${categoria}`);
                }
            } else {
                return this.$t(`mensagens.home.pesquisaInteligente.categoria.${categoria}`);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.pesquisa-inteligente {
    width: 100%;
    height: 46px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    .pesquisa-inteligente__categoria {
        font-size: 15px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
    }

    .counter {
        background: #3591384D;
        width: 15px;
        height: 15px;
        padding: 3px 8px 3px 8px;
        border-radius: 5px;
        font-size: 12px;
        font-weight: 500;
        line-height: 14px;
    }
}

.pesquisa-inteligente__input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    border-radius: 5px;
    color: var(--primary);
}

.pesquisa-inteligente__barra-pesquisa {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input:disabled {
        opacity: 0.5;
    }
}

.pesquisa-inteligente__ul {
    list-style: none;
    padding: 8px 24px 8px 24px;
    position: relative;
    z-index: 42;
    margin-top: 5px;
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    li {
        margin-top: 5px;
        cursor: pointer;
        display: flex;
        padding: 0 18px 0 18px;
        justify-content: space-between;
        align-items: center;
    }
}

.borda {
    border-bottom: solid 1px;
    border-color: #e4e7ed;
}

.pesquisa-inteligente__cadastro-container {
    display: flex;
    flex-direction: column;
    margin-top: 15px;

    .pesquisa-inteligente__cadastro {
        display: flex;
        justify-content: flex-start;
        align-items: baseline;
        flex-wrap: nowrap;
        margin-bottom: 10px;

        .fica-a-dica-titulo {
            font-size: 18px;
            font-weight: 500;
            line-height: 21px;
            letter-spacing: 0em;
            text-align: left;
            color: var(--primary);
        }

        .fica-a-dica-texto {
            font-size: 14px;
            font-weight: 500;
            line-height: 16px;
            letter-spacing: 0em;
            text-align: left;
            color: #3B3B3B;
        }
    }

    .pesquisa-inteligente__btn-cadastro {
        border-radius: 10px !important;
        padding: 5px 10px 5px 10px;
        height: 28px;
        background: #3591384D;
        color: var(--primary);
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        display: flex;
        align-items: flex-start;
        justify-content: center;

        &:hover {
            background-color: var(--secondary);
            color: var(--color-button-hover);

            i {
                color: var(--color-button-hover);
            }
        }

        [class^=el-icon] {
            font-size: 15px !important;
            font-weight: 500;
        }
        .lyra-icon {
            &:before {
                width: 13px;
                height: 13px;
            }
        }
    }
}
em {
    background-color: var(--secondary);
}

.lyra-icon::before {
    content: '';
    width: 20px;
    height: 20px;
    display: inline-block;
    background-color: var(--primary);
}

.lyra-icon:hover::before {
    background-color: var(--primary);

}

.lyra-icon-monitoramento::before {
    content: '';
    width: 25px;
    height: 25px;
    display: inline-block;
    background-color: var(--primary);
}

.lyra-icon-monitoramento:hover::before {
    background-color: var(--primary);

}

.icone {
    border: 0;
    transition: all 0.1s ease-in-out;
    border-radius: 5px;
    width: 40px;
    height: 30px;
    margin-bottom: 5px;
    justify-content: center;
    display: flex;
    align-items: center;

    &:hover,
    &:focus {
        background-color: var(--secondary);
        color: var(--color-button-hover);

        i {
            color: var(--color-button-hover);
        }
    }
}

.lyra-diagnostico-socio {
    margin-top: 1px;
    width: 20px;
    height: 20px;
}

.lyra-olho::before {
    -webkit-mask: url(../../assets/lyra-icons/svg/olho.svg) no-repeat 50% 50%;
    mask: url(../../assets/lyra-icons/svg/olho.svg) no-repeat 50% 50%;
    mask-size: cover;
    -webkit-mask-size: cover;
}

.lyra-olho {
    width: 20px;
    height: 20px;
}

.lyra-arvore::before {
    -webkit-mask: url(../../assets/lyra-icons/svg/arvore.svg) no-repeat 50% 50%;
    mask: url(../../assets/lyra-icons/svg/arvore.svg) no-repeat 50% 50%;
    mask-size: cover;
    -webkit-mask-size: cover;
}

.lyra-arvore {
    width: 20px;
    height: 20px;
}

.lyra-visualizar-monitoramento-socio-ambiental::before {
    -webkit-mask: url(../../assets/lyra-icons/svg/visualizar-monitoramento-socio-ambiental.svg) no-repeat 50% 50%;
    mask: url(../../assets/lyra-icons/svg/visualizar-monitoramento-socio-ambiental.svg) no-repeat 50% 50%;
    mask-size: cover;
    -webkit-mask-size: cover;
}

.lyra-visualizar-monitoramento-socio-ambiental {
    width: 22px;
    height: 24px;
}

.lyra-laudos {
    width: 20px;
    height: 20px;
}

.lyra-pre-analise-credito {
    margin-top: 1px;
    width: 20px;
    height: 20px;
}

.lyra-agricola::before {
    -webkit-mask: url(../../assets/lyra-icons/svg/agricola.svg) no-repeat 50% 50%;
    mask: url(../../assets/lyra-icons/svg/agricola.svg) no-repeat 50% 50%;
    mask-size: cover;
    -webkit-mask-size: cover;
}

.lyra-agricola {
    width: 20px;
    height: 20px;
}

</style>

<style>
.el-button.pesquisa-inteligente__btn-cadastro.socioambiental.el-button--default.el-button--medium > span {
    display: flex;
}
</style>
